import takeRequest from '~/store/takeRequest';
import { sendPushNotification } from './actions';

export function* notificationSaga(): Generator {
  yield takeRequest(sendPushNotification);
}
